@if (!resultsInGrid) {
  <div class="animate-pulse grid col-span-full mx-4 mb-4">
    <div
      *ngFor="let _ of [].constructor(4)"
      class="relative flex flex-row w-full h-40 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 my-2 hover:scale-[1.005]"
    >
      <svg
        class="p-1 hidden sm:flex bg-contain rounded-l-lg w-1/3 bg-gray-500 text-gray-200 dark:text-gray-600"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 18"
      >
        <path
          d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"
        />
      </svg>
      <div class="absolute top-2 right-4">
        <ng-icon
          name="bootstrapHeartFill"
          class="align-middle text-gray-400 dark:text-gray-700"
        ></ng-icon>
      </div>
      <a class="w-full cursor-pointer">
        <div class="p-4">
          <div class="flex flex-col w-full">
            <div>
              <div
                class="h-2.5 bg-gray-400 rounded-full dark:bg-gray-700 w-48 mb-4"
              ></div>
              <div class="flex flex-col w-full xs:flex-row py-2">
                <div class="flex pr-4 items-center mb-2">
                  <ng-icon
                    name="bootstrapGeoAltFill"
                    class="mr-2 text-gray-400 dark:text-gray-700"
                  ></ng-icon>
                  <div
                    class="h-2 bg-gray-400 rounded-full dark:bg-gray-700 w-20"
                  ></div>
                </div>
                <div class="flex pr-4 items-center mb-2">
                  <ng-icon
                    name="bootstrapBriefcase"
                    class="mr-2 text-gray-400 dark:text-gray-700"
                  ></ng-icon>
                  <div
                    class="h-2 bg-gray-400 rounded-full dark:bg-gray-700 w-20"
                  ></div>
                </div>
                <div class="flex items-center mb-2">
                  <ng-icon
                    name="bootstrapGlobe2"
                    class="mr-2 text-gray-400 dark:text-gray-700"
                  ></ng-icon>
                  <div
                    class="h-2 bg-gray-400 rounded-full dark:bg-gray-700 w-20"
                  ></div>
                </div>
              </div>
            </div>
            <div class="text-left rtl:text-right dark:text-white">
              <div
                class="h-2.5 bg-gray-400 rounded-full dark:bg-gray-700 w-full mb-4"
              ></div>
              <div
                class="h-2.5 bg-gray-400 rounded-full dark:bg-gray-700 w-full mb-4"
              ></div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
} @else {
  <div
    class="animate-pulse grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 mx-4 mb-4"
  >
    <div
      *ngFor="let _ of [].constructor(4)"
      class="relative bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700"
    >
      <div class="w-full h-28 p-1">
        <svg
          class="p-1 rounded-t-lg w-full h-full bg-contain bg-gray-500 text-gray-200 dark:text-gray-600"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 18"
        >
          <path
            d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"
          />
        </svg>
      </div>
      <div
        class="absolute flex items-center flex-wrap justify-center h-7 w-7 top-[7.75rem] right-4 cursor-pointer"
      >
        <ng-icon
          name="bootstrapHeartFill"
          class="align-middle text-gray-400 dark:text-gray-700"
        ></ng-icon>
      </div>
      <a class="w-full cursor-pointer">
        <div class="p-5">
          <div class="flex flex-row">
            <div
              class="h-2.5 bg-gray-400 rounded-full dark:bg-gray-700 w-48 mb-4"
            ></div>
          </div>
          <div class="flex flex-col pt-2 pb-4">
            <div class="flex pr-4 items-center mb-2">
              <ng-icon
                name="bootstrapGeoAltFill"
                class="mr-2 text-gray-400 dark:text-gray-700"
              ></ng-icon>
              <div
                class="h-2 bg-gray-400 rounded-full dark:bg-gray-700 w-24"
              ></div>
            </div>
            <div class="flex items-center mb-2">
              <ng-icon
                name="bootstrapBriefcase"
                class="mr-2 text-gray-400 dark:text-gray-700"
              ></ng-icon>
              <div
                class="h-2 bg-gray-400 rounded-full dark:bg-gray-700 w-24"
              ></div>
            </div>
            <div class="flex items-center">
              <ng-icon
                name="bootstrapGlobe2"
                class="mr-2 text-gray-400 dark:text-gray-700"
              ></ng-icon>
              <div
                class="h-2 bg-gray-400 rounded-full dark:bg-gray-700 w-24"
              ></div>
            </div>
          </div>
          <div class="text-left rtl:text-right dark:text-white">
            <div
              class="h-2.5 bg-gray-400 rounded-full dark:bg-gray-700 w-full mb-4"
            ></div>
            <div
              class="h-2.5 bg-gray-400 rounded-full dark:bg-gray-700 w-full mb-4"
            ></div>
          </div>
        </div>
      </a>
    </div>
  </div>
}
